module.exports = __webpack_public_path__ + "static/media/hardy-quizquestions-hooray.ae336338.svg";